import React, { FC, useEffect, useState } from 'react'

import { Grid, useTheme } from '@mui/material'
import { isEmpty, isEqual } from 'lodash'

import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import { fetchDurationReport } from '../ReportsSlice'

import { StressLevelCorrelationWidget } from './StressLevelCorrelationWidget'
import { TransactionLenMoneyWidget } from './TransactionLenMoneyWidget'
import { TransactionLenNumWidget } from './TransactionLenNumWidget'

export const Duration: FC = () => {
  const { spacing } = useTheme()
  const dispatch = useAppDispatch()

  const { duration } = useAppSelector(({ reports }) => reports)
  const { period, currentAccount } = useAppSelector(({ userAccounts }) => userAccounts)
  const [displayWidth, setDisplayWidth] = useState(window.innerWidth)

  useEffect(() => {
    const periodsIsEqual = duration?.meta?.period && period && isEqual(duration.meta.period, period)
    const isNeedToUpdate =
      isEmpty(duration) || !periodsIsEqual || currentAccount?.id !== duration?.meta.account

    if (currentAccount?.id && isNeedToUpdate) {
      dispatch(
        fetchDurationReport({
          account: currentAccount?.id,
          period: period,
        }),
      )
    }
  }, [period, currentAccount])

  useEffect(() => {
    const handleResize = () => {
      setDisplayWidth(window.innerWidth)
    }
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6} sm={12} height={spacing(42.25)} sx={{ pageBreakInside: 'avoid' }}>
        <TransactionLenNumWidget
          transactionsNumData={duration?.numberOfTransactions}
          displayWidth={displayWidth}
        />
      </Grid>
      <Grid item xs={12} md={6} sm={12} height={spacing(42.25)} sx={{ pageBreakInside: 'avoid' }}>
        <StressLevelCorrelationWidget
          stressLevelData={duration?.stressLevel}
          displayWidth={displayWidth}
        />
      </Grid>
      <Grid item xs={12} md={6} sm={12} height={spacing(42.25)} sx={{ pageBreakInside: 'avoid' }}>
        <TransactionLenMoneyWidget
          transactionsMoneyData={duration?.moneyEquivalence}
          currency={currentAccount?.currency}
          displayWidth={displayWidth}
        />
      </Grid>
    </Grid>
  )
}
